import React from 'react';


const OrderConfirmation = props =>(
  <div className = 'orderConfirm'>
    <h2>Your order has been placed!</h2>
    <h4>You will receive a confirmation email shortly.</h4>
    <h6>If you do not, check your spam folder and then contact us.</h6>
  </div>
)

export default OrderConfirmation;
